let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("khP6q")).then(() => parcelRequire('1JPa1'));